export default "__VITE_ASSET__NCGmC2DP__"